// extracted by mini-css-extract-plugin
export default {"fournisseurs":"fournisseurs_fournisseurs__SaRwW","content":"fournisseurs_content__gIqA0"};